import { sdk } from '@/sdk/CommercetoolsSDK';
import getCookieValue from '@/utils/cookie';
import { decodeToken } from '@/utils/token';
import { getAccountActions } from '@/sdk/composable-commerce-b2b/library/actions/AccountActions';

export class FeatureflagService {
    featureFlagsPromise: any;
    flags: Record<string, boolean>;
    businessUnitKey: string;
    accountId: string;

    constructor() {
        this.featureFlagsPromise = null;
        this.flags = {};
        this.businessUnitKey = '';
        this.accountId = '';
    }

    protected getFlagsData() {
        return new Promise(async (resolve, reject) => {
            resolve({});
        });
    }

    public async getFlags(): Promise<Record<string, boolean>> {
        try {
            const sessionCookie = getCookieValue('frontastic-session');
            const tokenInfo = decodeToken(sessionCookie ?? '');
            const accountId = this.accountId || tokenInfo?.account?.accountId;
            if (!this.featureFlagsPromise) {
                this.featureFlagsPromise = this.getFlagsData();
            }
            const response = await this.featureFlagsPromise;
            if (!accountId) {
                this.featureFlagsPromise = null;
            }
            this.flags = response?.data?.flags || {};
            return this.flags;
        } catch (e) {
            this.featureFlagsPromise = null;
            this.flags = {};
            console.log('failed to fetch featureFlags:: error:', e);
            return {};
        }
    }

    public isEnabled(flagName: string) {
        return true;
        // return this.flags[flagName] ?? true;
    }

    public async init() {
        await this.getFlags();
        return true;
    }
}
const featureflagService = new FeatureflagService();

export default featureflagService;
